export default __webpack_public_path__ + "static/media/wave.8ae479bf.svg";